document.addEventListener('click', (event) => {
  const variantSelector = event.target.closest('[class*="product-variant-picker"]');
  if (!variantSelector) return;

  const target = document.querySelector('product-form form[action*="/cart/add"]');
  if (!target) return;

  const observer = new MutationObserver(() => {
    const newForm = document.querySelector('product-form form[action*="/cart/add"]');

    if (newForm && newForm !== target) {
      observer.disconnect();
      document.dispatchEvent(new CustomEvent('teeinblue-event-clone-node'));
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // fallback
  setTimeout(() => {
    observer.disconnect();
    document.dispatchEvent(new CustomEvent('teeinblue-event-clone-node'));
  }, 3000);
});